/* TRY ON */

$("#open-try-on-drawer, #open-try-on-drawer-mobile").on("click", function () {
  $("#try-on-drawer").toggle();
  $("[data-section-type=header]").hide();
  var event = new CustomEvent("try-on");
  document.dispatchEvent(event);
  $("#my-fitmix-container").show();
});

$(".close-try-on-drawer").on("click", function () {
  $("#try-on-drawer").hide();
  $("[data-section-type=header]").show();
  var event = new CustomEvent("try-on-close");
  document.dispatchEvent(event);
});

var tryOnElement = document.getElementById("open-try-on-drawer");
if (tryOnElement) {
  var fittingboxColorSwatches = $("#try-on-drawer .fittingbox-color-swatches");
  var fittingboxProductTitle = $("#try-on-drawer .fittingbox-product-title");

  fittingboxColorSwatches.hide();
  fittingboxProductTitle.hide();
  
  document.addEventListener("try-on-close", function () {
    fitmixInstance.remove();
    fittingboxColorSwatches.hide();
    fittingboxProductTitle.hide();
  });

  document.addEventListener("try-on", function () {
    var get_lang = document.querySelector("html").getAttribute("lang");
    if (get_lang == "da") {
      get_lang = "dk";
    }
    var params = {
      apiKey: 'FKKyiL0aNESWKAlx1UDeYGlJY6Yw6RQ2o7J7pjXt',
      liveAutostart: true,
      mode: "live",
      lang: get_lang,
      watermark: false,
      onAgreePrivacyTerms: onAgreePrivacyTerms
    };
    fitmixInstance = FitMix.createWidget('my-fitmix-container',
      params,
      onFitMixReady
    );
  });

  function onAgreePrivacyTerms() {
    fittingboxColorSwatches.show();
    fittingboxProductTitle.show();
  }

  function onFitMixReady() {
    let initialFrame = $("#try-on-drawer").data("initial-frame");
    if (initialFrame) {
      fitmixInstance.setFrame(initialFrame);
    }

    function onColorClick(e) {
      var clicked = false;

      if (!clicked) {
        if (!e.target.classList.contains('color_swatch-selected')) {
          let productId = e.target.getAttribute('data-main-id');
          if (productId) {
            let frame = e.target.getAttribute('data-frame');

            fitmixInstance.setFrame(frame);

            onColorSwatchClick(e);

            clicked = true;
          }
        }
      }
    }
    const $selectedColor = $(document).find(".try-on-drawer a.selected .color_swatch")[0];
    const productId = $selectedColor.getAttribute('data-main-id');
    let frame;
    if (productId) { frame = $selectedColor.getAttribute('data-frame'); }
    fitmixInstance.setFrame(frame);

    $(document).on("click", ".try-on-drawer .color_swatch", onColorClick);
    $(document).find(".try-on-drawer .color_swatch")[0].click();
  }

  function onColorSwatchClick(e) {
    var colorSwatches = e.target.closest(".color-selection").querySelectorAll("a");
    var colorSwatch = e.target.closest("a");
    var colorSwatchImages = e.target.closest(".color-selection").querySelectorAll("img.color_swatch");
    var productTitle = e.target.getAttribute("data-title");
    var productTitleEle = e.target.closest(".try-on-drawer").querySelector(".fittingbox-product-title");

    for (var i = 0; i < colorSwatches.length; i++) {
      colorSwatches[i].classList.remove("selected");
    }
    colorSwatch.classList.add("selected");

    for (var i = 0; i < colorSwatchImages.length; i++) {
      colorSwatchImages[i].classList.remove("color_swatch-selected");
    }
    e.target.classList.add("color_swatch-selected");

    productTitleEle.innerHTML = productTitle;
  }
}